module.exports = __webpack_public_path__ + "img/r8.3790a760.jpg";